// extracted by mini-css-extract-plugin
export var actions = "_24-0";
export var actionsContainer = "_24-7";
export var border = "_24-1";
export var childFullHeight = "_24-f";
export var collapse = "_24-2";
export var content = "_24-a";
export var contentChild = "_24-e";
export var fullscreen = "_24-c";
export var hasLeftRadius = "_24-k";
export var headerContainer = "_24-3";
export var headerRow = "_24-5";
export var hidePadding = "_24-b";
export var navCollapsedGap = "_24-l";
export var noScrollX = "_24-m";
export var noScrollY = "_24-n";
export var noTopPadding = "_24-i";
export var optOutTopPadding = "_24-d";
export var pageMain = "_24-j";
export var pageOuter = "_24-g";
export var pagePadding = "_24-8";
export var pageScroll = "_24-9";
export var profile = "_24-o";
export var profileContainer = "_24-p";
export var profileImage = "_24-q";
export var profileMain = "_24-r";
export var profileSubtitle = "_24-t";
export var profileTitle = "_24-s";
export var showLeftPadding = "_24-h";
export var tabsPortalSlot = "_24-6";
export var tabsWrapper = "_24-4";
export var title = "_24-u";